<template>
  <div v-if="status == 1">
    <span class="text-lg font-bold" :class="`text-${color}`">作</span>
    <span class="text-sm font-bold" :class="`text-${color}`">成中</span>
  </div>
  <div v-if="status == 2">
    <span class="text-sm font-bold" :class="`text-${color}`">確認</span>
    <span class="text-lg font-bold" :class="`text-${color}`">待</span>
  </div>
  <div v-if="status == 3">
    <span class="text-lg font-bold" :class="`text-${color}`">再</span>
    <span class="text-sm font-bold" :class="`text-${color}`">確認</span>
  </div>
  <div v-if="status == 4">
    <span class="text-sm font-bold" :class="`text-${color}`">確認</span>
    <span class="text-lg font-bold" :class="`text-${color}`">済</span>
  </div>
  <div v-if="status == 5">
    <span class="text-sm font-bold" :class="`text-${color}`">確認</span>
    <span class="text-lg font-bold" :class="`text-${color}`">済</span>
  </div>
  <div v-if="status == 6">
    <span class="text-sm font-bold" :class="`text-${color}`">確認</span>
    <span class="text-lg font-bold" :class="`text-${color}`">待</span>
  </div>
  <div v-if="status == 7">
    <span class="text-lg font-bold" :class="`text-${color}`">再</span>
    <span class="text-sm font-bold" :class="`text-${color}`">確認</span>
  </div>
</template>
<script>
export default {
  name: 'AppReceiptStatusText',

  props: {
    status: {
      type: Number,
      default: 0,
    },
    color: {
      type: String,
      default: '',
    },
  },
}
</script>
